<template>
  <div
    class="preloader"
    :class="{ 'preloader--fullscreen': fullScreen }"
    role="status"
    aria-busy="true"
    :aria-label="ariaLabel"
  >
    <div class="preloader__overlay" aria-hidden="true" />
    <div class="preloader__spinner">
      <span class="preloader__ring" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AppPreloader",
  props: {
    fullScreen: {
      type: Boolean,
      default: true,
    },
    ariaLabel: {
      type: String,
      default: "Загрузка",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variables";

.preloader {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;

  &--fullscreen {
    position: fixed;
    inset: 0;
  }

  &:not(.preloader--fullscreen) {
    position: absolute;
    inset: 0;
  }

  &__overlay {
    position: absolute;
    inset: 0;
    background: $c-white;
  }

  &__spinner {
    position: relative;
    z-index: 1;
  }

  &__ring {
    display: block;
    width: 48px;
    height: 48px;
    border: 3px solid rgba($c-blue, 0.2);
    border-top-color: $c-blue;
    border-radius: 50%;
    animation: preloader-spin 0.75s linear infinite;
  }
}

@keyframes preloader-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
